import { Route } from '@angular/router';
import { featShellRoutes } from '@my-toolbox-fe/feat-shell';

export const appRoutes: Route[] = featShellRoutes
